'use strict';
var $ = require('jquery');
var Backbone = require('backbone');
var _ = require('underscore');
var Common = require('../common');

module.exports = Backbone.View.extend({

    initialize: function () {
        console.log('Initializing ChangeBuildingAccountPasswordView');

        Backbone.Validation.bind(this);
        Common.inputView = this;
    },

    events: {
        "click": "clicked",
        "click #save": "clickedSave",
        "click #cancel": "clickedCancel",

        //Validation
        "change input": "inputChanged",
        "focus input": "inputFocus",
        "blur input": "inputBlur"
    },

    //Cache the template function for a single item
    template: _.template($('#changeBuildingAccountPassword-template').html(), { interpolate: /\{\{(.+?)\}\}/g }),

    /////////////////////////////////////
    // Render
    /////////////////////////////////////
    render: function () {
        $(this.el).html(this.template(this.model.attributes));
        var self = this;
        $(function () {
        });
        return this;
    },

    /////////////////////////////////////
    // Validation
    /////////////////////////////////////
    inputChanged: function (eventName, args) {
        eventName.preventDefault();
        eventName.stopPropagation();
        eventName.stopImmediatePropagation();

        // Validate one attribute
        // The 'errorsMessage' returned is a string
        var attr = eventName.currentTarget.name;
        var value = eventName.currentTarget.value;
        var view = Common.inputView;
        view.$('#accountExistError').addClass('hidden');
        view.fillModelWithDataFromView();

        var error = view.model.preValidate(attr, value);

        if (error) {
            var $el = view.$('[name=' + attr + ']'),
                $group = $el.closest('.control-group');
            $group.addClass('has-error');
            $group.find('.help-block').html(error).removeClass('hidden');
        }
        else {
            var $el = view.$('[name=' + attr + ']'),
                $group = $el.closest('.control-group');
            $group.removeClass('has-error');
            $group.find('.help-block').html('').addClass('hidden');
        }
    },

    inputFocus: function (eventName, args) {
        eventName.preventDefault();
        eventName.stopPropagation();
        eventName.stopImmediatePropagation();

        //Skip validation if we enter a blank element, unless it has errors, OR its the 'repeatpassword' field
        var attr = eventName.currentTarget.name;
        var value = eventName.currentTarget.value;
        var view = Common.inputView;

        if (value == "") {
            var $el = view.$('[name=' + attr + ']'),
                $group = $el.closest('.control-group');
            if (!$group.hasClass('has-error')) {
                if (attr != "repeatPassword") {
                    return;
                }
            }
        }

        //Subscribe to 'input' change events to update validation live
        var id = "#" + eventName.currentTarget.id;
        $(id).on('input', this.inputChanged);
    },

    inputBlur: function (eventName, args) {
        eventName.preventDefault();
        eventName.stopPropagation();

        var id = "#" + eventName.currentTarget.id;
        $(id).off('input', this.inputChanged);

        //Always run validaton when we leave a field
        this.inputChanged(eventName, args);
    },

    fillModelWithDataFromView: function () {
        var form = $("form:first-of-type");
        var data = form.serializeObject();
        this.model.set(data);
    },

    /////////////////////////////////////
    // User actions
    /////////////////////////////////////
    clicked: function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        $(".dropdown").fadeOut(100);
    },

    clickedSave: function (e) {
        e.preventDefault();
        e.stopPropagation();

        //Validate
        $('#serverError').text("").hide();// Hide any servers on a new submit
        if (!this.model.isValid(true)) {
            return;
        }

        //Update
        this.model.update();

        this.destroy();
        Common.appView.closeDialog();
    },

    clickedCancel: function (e) {
        e.preventDefault(); // Don't let this button submit the form
        e.stopPropagation();

        this.destroy();
        Common.appView.closeDialog();
    },


    /////////////////////////////////////
    // Dispose
    /////////////////////////////////////
    destroy: function () {
        this.remove();
        return Backbone.View.prototype.remove.apply(this, arguments);
    }
});